import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../api/axios'; // Importamos el cliente Axios configurado

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  
  // Establece el título de la página
  useEffect(() => {
    document.title = 'Medisys | Login';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Limpiar errores previos

    try {
      // 1. Llamada al endpoint de autenticación de Laravel
      const response = await api.post('/login', { email, password });
      
      // 2. Extraer el token de la respuesta
      const token = response.data.access_token;
      
      // 3. Guardar el token de forma segura en el almacenamiento local
      localStorage.setItem('laravel_auth_token', token);
      
      // 4. ¡CAMBIO CLAVE AQUÍ! Redirigir a la página de Reportes
      // Asegúrate de que esta ruta '/reportes' coincida con la ruta definida en tu archivo de rutas principal.
      navigate('/reportes'); 

    } catch (err) {
      // 5. Manejo de errores de autenticación
      if (err.response && err.response.status === 401) {
        setError('Credenciales incorrectas. Verifica tu email y contraseña.');
      } else {
        setError('Error al conectar con el servidor. Intenta de nuevo.');
        console.error("Error de Login:", err);
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 p-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-xl">
        {/* Logo */}
        <div className="flex justify-center mb-6">
            <svg className="w-12 h-12 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.86 5.34a7 7 0 109.28 9.28l-2.09-2.09a5 5 0 11-7.1 7.1l-2.09 2.09M12 2v20"></path></svg>
        </div>
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Medical Cleth</h1>
        <p className="text-center text-gray-600 mb-8">Accede a tu panel de gestión</p>

        {/* Mensaje de Error */}
        {error && (
            <div className="mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                <span className="block sm:inline">{error}</span>
            </div>
        )}

        {/* Formulario */}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
              Correo electrónico
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              id="email"
              type="email"
              placeholder="nombre@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              Contraseña
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              id="password"
              type="password"
              placeholder="**********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded w-full focus:outline-none focus:shadow-outline transition duration-150"
              type="submit"
            >
              Entrar
            </button>
          </div>
        </form>

        {/* Footer */}
        <p className="text-center text-gray-500 text-xs mt-6">
          © 2025 Medical Cleth. Todos los derechos reservados.
        </p>
      </div>
    </div>
  );
}